module.exports = __webpack_public_path__ + "static/media/hw-file-unopened.645ae6cd.svg";